import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { StoreReviewService } from '../../services/store-review.service';
import { NgClass } from '@angular/common';
import { RouterLinkWithLang } from '../../directives/router-link-with-lang/router-link-with-lang.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'service-menu',
  templateUrl: './service-menu.component.html',
  styleUrls: ['./service-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, TranslatePipe, RouterLink, RouterLinkWithLang],
})
export class ServiceMenuComponent implements OnInit {
  protected storeReviewService = inject(StoreReviewService);

  readonly layout = input<'horizontal' | 'vertical'>('horizontal');
  readonly isInFooter = input<boolean>(false);
  readonly isInSidebar = input<boolean>(false);

  ngOnInit() {
  }

}
